export enum SnackbarType {
  info,
  success,
  warning,
  error,
}
